import React from 'react';
import HouseDetails from '../ui/HouseDetails';
import "./agent-ui.css";

const AgentHouseView = () => {

  return (
    <div className='agent-house_view'>
      <HouseDetails houseWidth={"100%"} styleBg={"white"} leftWidth={"100%"} />
    </div>
  )
}

export default AgentHouseView